var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.16666 1C1.52706 1 1 1.52706 1 2.16666V3.72225C1 4.22552 1.32708 4.65702 1.77773 4.81898V13.0556C1.77773 14.1249 2.65299 15 3.72225 15H12.2779C13.347 15 14.2223 14.1249 14.2223 13.0556V4.81898C14.6729 4.657 15 4.22548 15 3.72225V2.16666C15 1.52706 14.4729 1 13.8333 1H2.16666ZM2.16666 1.77773H13.8333C14.0554 1.77773 14.2222 1.94453 14.2222 2.16666V3.72225C14.2222 3.94439 14.0554 4.11105 13.8333 4.11105H2.16666C1.94453 4.11105 1.77773 3.94439 1.77773 3.72225V2.16666C1.77773 1.94453 1.94453 1.77773 2.16666 1.77773ZM2.55559 4.88891H13.4442V13.0555C13.4442 13.7045 12.9265 14.2222 12.2775 14.2222H3.72225C3.07329 14.2222 2.55559 13.7045 2.55559 13.0555V4.88891Z",
    fill: "#000000",
    stroke: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.05562 6.44141C5.84078 6.44141 5.66669 6.61563 5.66669 6.83034C5.66669 6.93346 5.7077 7.03242 5.78062 7.10534C5.85354 7.17825 5.95249 7.21927 6.05562 7.21927H9.9446H9.94447C10.0476 7.21927 10.1466 7.17825 10.2195 7.10534C10.2924 7.03242 10.3334 6.93346 10.3334 6.83034C10.3334 6.72721 10.2924 6.62826 10.2195 6.55534C10.1466 6.48242 10.0476 6.44141 9.94447 6.44141H6.05562Z",
    fill: "#000000",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.46b69f08b94e801544d57ce315744857.svg";
export { ForwardRef as ReactComponent };